import Configuracao from '../../../../spa/configuracao/Configuracao';

export default {
  path: 'configuracao',
  name: 'configuracao',
  component: Configuracao,
};



// WEBPACK FOOTER //
// ./src/custom/abbrasil/config/router/configuracao.js